import posthog from "posthog-js";

const userId = document.cookie
  .split('; ')
  .find(row => row.startsWith('userId='))
  ?.split('=')[1];

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  capture_pageview: "history_change",
  capture_exceptions: true,
  capture_dead_clicks: true,
  capture_pageleave: true,
  debug: process.env.NODE_ENV === "development",
});

if (userId) {
  posthog.identify(userId);
}